module.exports = __webpack_public_path__ + "img/line5.35719eaf.svg";